import React from 'react';
// import Container from 'common/components/UI/Container';
import { BannerWrapperNav } from '../Banner/banner.style';
import ImageContainer from './ImageContainer/ImageContainer';
import HeadContainer from './HeadContainer/HeadContainer';
import styled from 'styled-components';
import { SliceZone } from '@prismicio/react';
import Link from 'next/link';
import Button from 'common/components/Button';
import PropTypes from 'prop-types';
import Box from 'common/components/Box';
import { components } from 'slices';
import BotsCategory from 'common/components/BotLists/BotsCategory/BotsCategory';
import Text from 'common/components/Text';
import { BotContainer } from './style.botPage';
import CategorySection from '../AiHUb/Category';
import Container from 'common/components/Container';
import { fontSize } from 'styled-system';

const LinkButton = styled(Link)`
  margin: auto;
`;

const BotPage = ({
  botData,
  botPage,
  secText,
  botTagsData,
  aiStoreData,
  buttonFillTryItStyle,
  BoxButtonTryIt,
}) => {
  return (
    <>
      <BotContainer>
        <Container>
          <HeadContainer data={botData} cta_text={botPage?.data?.cta_text} />
          {Object.keys(botPage).length !== 0 ? (
            <>
              <ImageContainer bot_images={botPage.data.images} />
              <SliceZone
                slices={botPage?.data?.slices}
                components={components}
              />
              <Box {...BoxButtonTryIt}>
                <LinkButton href={`https://app.swiftask.ai/?bot=${botData.id}`}>
                  <Button
                    title={botPage.data.cta_text}
                    {...buttonFillTryItStyle}
                  />
                </LinkButton>
              </Box>
            </>
          ) : null}
          <Text {...secText} content={'Explore more AIs'} />
        </Container>
        <CategorySection bots={aiStoreData}  />
      </BotContainer>
    </>
  );
};
BotPage.propTypes = {
  buttonFillTryItStyle: PropTypes.object,
  BoxButtonTryIt: PropTypes.object,
  secText: PropTypes.object,
};

BotPage.defaultProps = {
  BoxButtonTryIt: {
    width: '100%',
    display: 'flex',
    marginTop: '20px',
    mb: '40px',
    justifyContent: 'center',
  },
  secText: {
    as: 'span',
    display: 'block',
    textAlign: 'center',
    fontSize: '24px',
    letterSpacing: '0.15em',
    fontWeight: '700',
    color: '#2E4057',
    mb: '5px',
  },
  buttonFillTryItStyle: {
    type: 'button',
    fontSize: '14px',
    borderRadius: '4px',
    color: '#fff',
    colors: 'primaryWithBg',
    width: '150px',
    maxWidth: '100%',
  },
};
export default BotPage;
